<div class="controls" *ngIf="enableRotation">
  <mat-icon (click)="rotateLeft()">rotate_left</mat-icon>
  <mat-icon (click)="rotateRigth()">rotate_right</mat-icon>
</div>
<div class="page-holder">
  <div class="image-holder">
    <div class="image-src" [ngStyle]="_backgroundStyle">
      <div class="verified" *ngIf="showBadge">
        <mat-icon>check</mat-icon>
      </div>
      <img id="image-view-element" #dom_image [src]="imageSource" (dragstart)="isDraggable()" [ngClass]="getClasses()"
        [default]="alt"
        [ngStyle]="{'max-height':maxHeight, 'height':getImageHeight(), 'max-width':maxWidth,  'border-radius':radius, 'border':border}"
        (click)="onImageClick()" />
    </div>
    <gio-progress *ngIf="progress>0" [percentage]=progress></gio-progress>

  </div>

</div>
